
> "I just don’t like when scrum masters pretend to be coders which was what was happening with -----."

> "Wisest is he who knows he does not know." - from HH today at work

> "I know nothing.
> 
> I am Jon Snow.
> 
> I’m Luke Skywalker on Dagobah."

The context of the above chain is something that happened at work today. I had a discussion with a coworker yesterday about nihilism vs anti-nihilism and we're left at this point. According to my Meyers Briggs I'm a "turbulent protagonist" which is a very weird way to describe people IMO. Everyone is the protagonist of their own life, no?

Anyhoo, I need to dial down the passion and stop looking for criticisms and support people and build them up. I think I have it out for "middle management" that stems back from my "Boomer" father leaving his position of 35 years when I was in high school. I want to have loyalty to a company but it's a hard pill to swallow.

# Walking Around the Neighborhood

2 walks tonight with the family. Fish and stir fry vegetables for dinner. Feeling really good with proper meals at home.

It's weird to try and find enough time in the day to:

- wake up early enough
- go for a run
- eat a banana and take meds
- work a full morning
- eat a lunch
- work the afternoon
- nap if needed
- evening meetings and recaps
- walk around the neighborhood
- dinner
- another walk around the neighborhood
- personal work

# Side Project Work Tonight

Tonight I set off to explore the magical world of NPM packages and scopes on GitHub. The annoying part is that they make it specific to your scope. The package repository is site wide even if they are private which makes it annoying to have a private to public feature path.

# GitHub Actions

**Initial thought:**

- very intuitive
- `GITHUB_TOKEN` set and ready to go

**Middle of the road opinions:**

- don't use `GITHUB_*` prepend

**Annoyances:**

- can't use any old scope
- have to use org or user scope for NPM
- 1 package per repo
- "GITHUB_TOKEN cannot install packages from any private repository besides the repository where the action runs."
- why oh why do I need to have my GitHub token to install my own packages from non-private repo?

# Other Thoughts

> "Every email company should auto whitelist gmail-style plus aliases!!!"

This frustrates the hell out of me because ABI at work doesn't use this format which means that I have to use my personal gmail to test certain applications. G-Suite has this enabled by default and everyone else should turn this on too!

Let's see if ABI Azure Active Directory will start whitelisting aliases...

Email me at <a href="mailto:christian.d.battaglia+i-love-email-aliases@gmail.com">christian.d.battaglia+i-love-email-aliases@gmail.com</a> with your Venmo username and I'll toss ya $5!






